import { AxiosResponse } from 'axios';
import api from './ApiHandler';

export const downloadFile = async (response: any) => {
  const objectUrl: any = window.URL.createObjectURL(response?.data);
  const element: any = document.createElement('a');
  element.href = objectUrl;
  element.download = response?.config?.url + '.' + response?.config?.params?.downloadType;
  document.body.appendChild(element);
  element.click();

  // Clean up by revoking the object URL and removing the link
  window.URL.revokeObjectURL(objectUrl);
  element.remove();

  return response?.status;
};

export const downloadFileOWrkingButNotUsed = async (url: any, payload: any) => {
  let response: AxiosResponse = await api.get(url, {
    params: payload,
    responseType: 'blob'
  });

  const objectUrl: any = window.URL.createObjectURL(response?.data);
  const element: any = document.createElement('a');
  element.href = objectUrl;
  element.download = url + '.' + payload?.downloadType; // Specify the file name
  document.body.appendChild(element);
  element.click();

  // Clean up by revoking the object URL and removing the link
  window.URL.revokeObjectURL(objectUrl);
  element.remove();

  return response?.status;
};
